import { WSList, WSPanel, WSText } from "@wingspanhq/fe-component-library";
import { useMemo } from "react";
import { FlowMEChangeContext } from "..";
import { queriesPersons } from "@query";
import { useSession } from "@hooks/useSession";
import { useFlowContext } from "../../../../../shared/components/Flow";
import { verificationService } from "../../../../../shared/services/verificaiton";
import { getProfileDataPersonV3 } from "../../../components/FormPartialPerson/getProfileDataPersonV3";
import { FormPersonalInformation } from "../../../components/FormPersonalInformation";
import { useRequiresBankingVerification } from "../../../hooks/useRequiresBankingVerification";
import { useMissingFields } from "../../../hooks/useMissingFields";

import { FlowStep } from "../../../../../shared/components/FlowSwitch/types";

export const StepMaterialUpdatePersonalInformation: React.FC<
  FlowStep
> = props => {
  const [context, setContext] = useFlowContext<FlowMEChangeContext>();
  const requiresBanking = useRequiresBankingVerification();
  const verificationLevel = requiresBanking ? "Banking" : "Tax";

  const session = useSession();
  const queryPerson = queriesPersons.getPerson.useQuery({
    personId: session.personId
  });
  const profileData = useMemo(
    () => ({
      person: getProfileDataPersonV3({
        type: "Individual",
        person: queryPerson.data
      })
    }),
    [queryPerson.data]
  );

  const missingFields = useMissingFields(verificationLevel);

  const isMismatch = useMemo(
    () => verificationService.getIsIndividualMismatch(missingFields),
    [missingFields]
  );

  // These forms compute their defaults once, at mount, so the read the prefill
  // comes from has to have settled first — otherwise the fields stay empty.
  if (!queryPerson.isFetched) {
    return <WSPanel shimmer />;
  }

  return (
    <WSList gap="2XL">
      <FormPersonalInformation
        defaultValues={context.personalInformation || profileData}
        onBack={props.onBack}
        onSubmit={data => {
          setContext(prev => ({ ...prev, personalInformation: data }));
          props.onNext?.();
        }}
        country={context.accountType?.country || "US"}
        mismatch={isMismatch}
      />

      <WSText.ParagraphXs color="gray400">
        The information on this page is required to request a taxpayer
        information update, if you exit or leave without completing this step,
        it will cancel the request.
      </WSText.ParagraphXs>
    </WSList>
  );
};
